import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { syndicationFeedApi, SyndicationFeed } from "api/syndicationFeed";
import { getFeedErrorMessage } from "./feedErrorMessage";

const feedSettingsQueryKey = (feed: SyndicationFeed) => [
  "SYNDICATION_FEED",
  feed,
  "SETTINGS"
];

export const useFeedStatus = (feed: SyndicationFeed) =>
  useQuery({
    queryKey: feedSettingsQueryKey(feed),
    queryFn: () => syndicationFeedApi.getFeedStatus(feed),
    meta: {
      onError: (error: unknown) => toast.error(getFeedErrorMessage(error))
    }
  });

export const useUpdateFeedSettings = (feed: SyndicationFeed) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [...feedSettingsQueryKey(feed), "UPDATE"],
    mutationFn: (autoAddListings: boolean) =>
      syndicationFeedApi.updateFeedSettings(feed, {
        auto_add_listings: autoAddListings
      }),
    onSuccess: (data) =>
      queryClient.setQueryData(feedSettingsQueryKey(feed), data),
    onError: (error) => toast.error(getFeedErrorMessage(error))
  });
};
